type ProfileName = { first_name: string | null; last_name: string | null };

export function profileToDisplayName(profile: ProfileName | undefined): string | null {
  if (!profile) return null;
  const name = [profile.first_name, profile.last_name].filter(Boolean).join(' ').trim();
  return name || null;
}

export function resolveReaderDisplayName(
  userId: string,
  profilesMap: Record<string, ProfileName>,
  senderNameByUserId: Record<string, string>
): string {
  const fromProfile = profileToDisplayName(profilesMap[userId]);
  if (fromProfile) return fromProfile;

  const fromMessage = senderNameByUserId[userId]?.trim();
  if (fromMessage) return fromMessage;

  return 'Unknown';
}

export function buildSenderNameByUserId(
  messages: { user_id: string; sender_name: string | null }[]
): Record<string, string> {
  const map: Record<string, string> = {};
  for (const message of messages) {
    const name = message.sender_name?.trim();
    if (message.user_id && name) {
      map[message.user_id] = name;
    }
  }
  return map;
}
